import { useLocation } from "react-router"
import { AUTH_EXCLUDED_ROUTES } from "../common/constants"
import { useEffect } from "react"

export const useisAuthCheckRequired = () => {
    const mainPath = useLocation().pathname.split("/")[1]
    return !AUTH_EXCLUDED_ROUTES.includes(mainPath)
}

export const useShowBlankPage = () => {
    const mainPath = useLocation().pathname.split("/")[1]
    return 'chat-landing' === mainPath
}

export const useCloseChatBot = () => {
    const path = useLocation().pathname;
    const showBlankPage = useShowBlankPage(); 

    useEffect(() => {
        if (!showBlankPage) {
            window.YellowMessengerPlugin?.closeBot();
        }
    }, [path, showBlankPage]);
}